// extracted by mini-css-extract-plugin
export default {"main__container":"Template_main__container__iUwR+"};